import { render } from "./RadioComponent.vue?vue&type=template&id=6e308744&scoped=true"
import script from "./RadioComponent.vue?vue&type=script&lang=js"
export * from "./RadioComponent.vue?vue&type=script&lang=js"

import "./RadioComponent.vue?vue&type=style&index=0&id=6e308744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e308744"]])

export default __exports__